import { useRoutes } from 'react-router-dom';
import Login from "./hoc";
import Email from "./hoc/email";
import VerifyTwoFactor from "./hoc/verify-two-factor";
import SetupTwoFactor from "./hoc/setup-two-factor";
import ResetPassword from "./hoc/reset-password";

import ROUTES from './routes';

export const routes = {
  path: ROUTES.LOGIN,
  element: <Login />,
  children: [
    {
      path: ROUTES.LOGIN_EMAIL,
      element: <Email />,
    },
    {
      path: ROUTES.LOGIN_VERIFY_TWO_FACTOR,
      element: <VerifyTwoFactor />,
    },
    {
      path: ROUTES.LOGIN_SETUP_TWO_FACTOR,
      element: <SetupTwoFactor />,
    },
    {
      path: ROUTES.LOGIN_RESET_PASSWORD,
      element: <ResetPassword />,
    },
  ],
};

const AuthRoutes = () => {
  const elements = useRoutes([{ ...routes }]);

  return elements;
};

export default AuthRoutes;
